let url = process.env.VUE_APP_API_ROOT

if (location.host.includes('serveo.net')) {
  url = 'https://pdc-api.serveo.net/'
}

export default url
